import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ChoiceGroup } from '@fluentui/react';
import { BrandListsPicker } from '../brand-lists-picker';

const OPTION_KEYS = {
  OFF: 'off',
  ON: 'on',
};

const OPTIONS = [
  {
    key: OPTION_KEYS.OFF,
    text: _TL_('Off: Use exact and phrase keyword matching'),
  },
  {
    key: OPTION_KEYS.ON,
    text: 'On: Use broad keyword matching',
  },
];

const getStyles = () => ({
  BroadOnlySetting: {
  },
  BroadOnlyChoiceGroup: {
    '& label': {
      padding: 0,
      fontWeight: 'normal',
      '&::before': {
        marginTop: 3,
      },
      '&::after': {
        marginTop: 3,
      },
    },
  },
  BrandListsPickerOption: {
    marginLeft: 26,
    '& .brand-lists-picker-description': {
      margin: '12px 0',
      fontSize: 14,
    },
  },
});

export const BroadOnlySetting = ({
  className,
  isBroadMatchOnly,
  setIsBroadMatchOnly,
  cid,
  aid,
  campaignId,
  onBrandListsChange,
  onSelectedBrandListsUpdate,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);
  const [isOn, setIsOn] = useState(isBroadMatchOnly);

  const options = OPTIONS.map(option => ({
    key: option.key,
    text: i18n.getString(option.text),
    ariaLabel: i18n.getString(option.text),
  }));

  const handleChange = (ev, option) => {
    setIsBroadMatchOnly(option.key === OPTION_KEYS.ON);
    setIsOn(option.key === OPTION_KEYS.ON);
  };

  return (
    <div className={classNames(classes.BroadOnlySetting, 'broad-only-setting', className)}>
      <ChoiceGroup
        className={classNames(classes.BroadOnlyChoiceGroup, 'broad-only-choice-group')}
        options={options}
        selectedKey={isOn ? OPTION_KEYS.ON : OPTION_KEYS.OFF}
        onChange={handleChange}
      />
      {
        isOn && (
          <div className={classes.BrandListsPickerOption}>
            <BrandListsPicker
              className="search-campaign-brand-lists-picker"
              cid={cid}
              aid={aid}
              campaignId={campaignId}
              onChange={onBrandListsChange}
              onSelectedOptionsUpdate={onSelectedBrandListsUpdate}
              isConfirmDialogOn
              descriptionTextTemplate={i18n.getString(_TL_('Add brand protections so that your ads will show on search queries that mention those brands. You can add up to {{count}} brand lists to your Search campaign. To manage your brand lists, go to {{link}}Brand lists{{/link}}.'))}
              noInitialDataText={i18n.getString(_TL_('Create a brand list so that your ads serve on search queries that mention those brands.'))}
            />
          </div>
        )
      }
    </div>
  );
};

BroadOnlySetting.propTypes = {
  className: PropTypes.string,
  isBroadMatchOnly: PropTypes.bool.isRequired,
  setIsBroadMatchOnly: PropTypes.func.isRequired,
  cid: PropTypes.number.isRequired,
  aid: PropTypes.number.isRequired,
  campaignId: PropTypes.number,
  onBrandListsChange: PropTypes.func,
  onSelectedBrandListsUpdate: PropTypes.func,
};

BroadOnlySetting.defaultProps = {
  className: '',
  campaignId: null,
  onBrandListsChange: () => {},
  onSelectedBrandListsUpdate: () => {},
};
